import Modal from '@components/Modal';
import { ReactElement, useState } from 'react';
import ActionEditForm from '@components/ActionEditForm';
import { ArrowCircleLeft } from '@phosphor-icons/react';

import s from './EditWorkflowStepModal.module.scss';

type Props = {
  workflow: Parameters<typeof ActionEditForm>[0]['workflow'];
  currentStep: Parameters<typeof ActionEditForm>[0]['action'];
  onClose: () => void;
  onSave: () => void;
};

const EditWorkflowStepModal = ({ currentStep, onClose, onSave, workflow }: Props): ReactElement => {
  const [currentPage, setCurrentPage] = useState<'edit-step' | 'send-email'>('edit-step');
  const title = (() => {
    switch (currentPage) {
    case 'edit-step':
      return 'Edit Step';
    case 'send-email':
      return 'Completion Email';
    default:
      return 'Edit Step';
    }
  })();
  return (
    <Modal
      hideBottomInset
      title={title}
      onClose={currentPage === 'send-email' ? () => setCurrentPage('edit-step') : onClose}
      closeIcon={currentPage === 'send-email' ? <ArrowCircleLeft weight='fill' size={24} color="var(--color-gray-100)" /> : undefined}
    >
      <div className={s.editWorkflow}>
        <ActionEditForm
          action={currentStep}
          onFinishEdit={onSave}
          workflow={workflow}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>
    </Modal>
  );
};

export default EditWorkflowStepModal;
